import Signposting, { SignpostType } from '../../../Components/Signposting';
import * as React from 'react';
import { flow } from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';

export class RenewalMedicalDecline extends React.Component<any, any> {

  goBack = () => {
    const { actions } = this.props;
    actions.push('/account/summary')
  }

  render() {
    return (
      <>
        <Signposting medical={true} type={SignpostType.TYPE_A}/>
        <div className="btn-bar btn-bar--auto-height">
          <div onClick={this.goBack} className="return-to-account-btn mt-15">
            GO BACK
          </div>
          <div className="clearfix"/>
        </div>
      </>
    )
  }

}

export default flow([
  connect(null,
    (dispatch) => ({
      dispatch,
      actions: {
        push: bindActionCreators(push, dispatch),
      },
    }),
  ),
])(RenewalMedicalDecline);

